import styled from 'styled-components';

const ModalSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export default ModalSection;
